import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../_services/auth/auth.service';

@Component({
  selector: 'gatewee-web-assume-role',
  templateUrl: './assume-role.component.html',
  standalone: false,
})
export class AssumeRoleComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    const queryParams = this.route.snapshot.queryParams;
    const token = queryParams['token'];
    const refreshToken = queryParams['refreshToken'];
    const tokenExpiresIn = Number(queryParams['tokenExpiresIn']);
    const refreshTokenExpiresIn = Number(queryParams['refreshTokenExpiresIn']);

    if (token && refreshToken && tokenExpiresIn && refreshTokenExpiresIn) {
      const now = Date.now();
      localStorage.setItem('accessToken', token);
      localStorage.setItem(
        'accessTokenExpiresIn',
        String(now + tokenExpiresIn * 1000),
      );
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem(
        'refreshTokenExpiresIn',
        String(now + refreshTokenExpiresIn * 1000),
      );

      this.authService.profile().subscribe({
        next: () => void this.router.navigate(['/panel']),
        error: () => void this.router.navigate(['/panel']),
      });
    }
  }
}
